import React from 'react';
import PropTypes from 'prop-types';
import PieChart from '../../../../core/chart/PieChart';
import Card from '../../../../core/layout/Card';
import Async from '../../../../core/layout/Async';

export default function ErrorsPerLevelChart(props) {
  const total = props.data.map((level) => level.errors).reduce((acc, level) => acc + level, 0);

  return (
    <Card title="Errors per Level">
      <Async fetching={props.isFetching}>
        <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {props.data.length > 0 ? (
            <PieChart
              data={props.data.map((level) => level.errors)}
              labels={props.data.map((level) => level.level)}
              colors={[
                '#251657',
                '#43397F',
                '#615EA8',
                '#8186D3',
                '#A2B0FF',
                '#A07FC7',
                '#00C7DB',
                '#009AC8',
                '#006DAC',
                '#174185',
              ]}
              options={{
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      const value = data.datasets[0].data[tooltipItem.index];
                      return `${data.labels[tooltipItem.index]}: ${value} (${((value / total) * 100).toFixed(1)}%)`;
                    },
                  },
                },
              }}
            />
          ) : (
            <span>No errors found.</span>
          )}
        </div>
      </Async>
    </Card>
  );
}

ErrorsPerLevelChart.propTypes = {
  data: PropTypes.array,
  isFetching: PropTypes.bool,
};

ErrorsPerLevelChart.defaultProps = {
  isFetching: false,
};
